import { render, staticRenderFns } from "../../assets/templates/StartPlataformas/FDVPage.html?vue&type=template&id=22dfcf48&scoped=true&"
import script from "../../assets/scripts/StartPlataformas/FDVPage.js?vue&type=script&lang=js&"
export * from "../../assets/scripts/StartPlataformas/FDVPage.js?vue&type=script&lang=js&"
import style0 from "../../assets/scss/fdvPage.scss?vue&type=style&index=0&id=22dfcf48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dfcf48",
  null
  
)

export default component.exports